import * as React from "react";

function SvgIconfeatherSearch(props) {
  return (
    <svg width={14.414} height={14.414} {...props}>
      <g
        data-name="Icon feather-search"
        fill="none"
        stroke="#f7a51b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          data-name="Caminho 53"
          d="M11.667 6.333A5.333 5.333 0 116.333 1a5.333 5.333 0 015.334 5.333z"
        />
        <path data-name="Caminho 54" d="M13 13l-2.9-2.9" />
      </g>
    </svg>
  );
}

export default SvgIconfeatherSearch;
